import { Button, DialogContent, Stack, Typography } from "@mui/material";
import { type FC } from "react";

import { AppSignUpButton } from "~/feature/auth/components/AppSignUpButton";

interface IGuestLimitDialogContentProps {
  onClose: () => void;
}

export const GuestLimitDialogContent: FC<IGuestLimitDialogContentProps> = ({
  onClose,
}) => {
  return (
    <DialogContent>
      <Stack
        sx={{
          alignItems: "center",
          gap: 2
        }}>
        <Typography variant="caption">
          Create a free account to save your events and unlock alerts.
        </Typography>
        <Button onClick={onClose}>
          <AppSignUpButton />
        </Button>
      </Stack>
    </DialogContent>
  );
};
